import type { InvoiceOrEstimate } from '~/types'

export const PAYMENT_REQUEST_SEND_ERROR_KINDS = [
  'MESSAGE_DIDNT_SEND',
  'TEMPLATE_COULDNT_BE_CREATED',
  'MESSAGE_CANT_BE_SEND',
  'CONNECTION_ISSUE',
] as const

export type PaymentRequestSendErrorKind =
  (typeof PAYMENT_REQUEST_SEND_ERROR_KINDS)[number]

export enum PaymentRequestFlowState {
  REQUEST_FORM = 'REQUEST_FORM',
  SENDING = 'SENDING',
  SUCCESS = 'SUCCESS',
}

export type PaymentRequestSendSuccessPayload = {
  conversationId?: string
  isDeposit: boolean
  recipientDisplay: string
}

/** Wired from container until backend send is implemented. */
export type PaymentRequestOnSendStubSuccess = (
  payload: PaymentRequestSendSuccessPayload,
) => void

export type DeliveryMethod = 'email' | 'sms'

export interface SendToRecipient {
  email?: string
  id: string
  name: string
  phone?: string | null
}

export interface PaymentRequestDialogStateType {
  clinicNotes: string
  deliveryMethod: DeliveryMethod
  flowState: PaymentRequestFlowState
  sendTo: SendToRecipient[]
  successPayload: PaymentRequestSendSuccessPayload | null
}

export interface PaymentRequestDialogContextType {
  actions: {
    dismissSendError: () => void
    resetDialogState: () => void
    sendPayment: () => void | Promise<void>
    setClinicNotes: (notes: string) => void
    setDeliveryMethod: (method: DeliveryMethod) => void
    setSendTo: (recipients: SendToRecipient[]) => void
  }
  dialogState: PaymentRequestDialogStateType
  invoice: InvoiceOrEstimate
  sendError: PaymentRequestSendErrorKind | null
}
